<template>
    <div>
      <div>
        <b-field>
          <p class="control">
            <button type="button" class="button" @click.prevent="toggleLocationModal">
              <font-awesome-icon :icon="['far', 'address-book']" />
              <span class="is-size-7 icon-help-text">Address Book</span>
            </button>
          </p>
          <b-autocomplete v-model="searchString"
                          expanded
                          icon="fas fa-search"
                          :open-on-focus="true"
                          autocomplete.native="false"
                          :clear-on-select="false"
                          :data="matches"
                          :loading="isSearching"
                          @keyup.native="notifyOnInputChange"
                          @input.native="search"
                          @select="notifyOnSelection"
                          ref="searchBox">
            <template slot-scope="props">
              <div>
                {{ props.option.companyRolodexJobLocationName }} ( {{props.option.companyRolodexJobLocationAddressStreet1}} -- {{props.option.companyRolodexJobLocationAddressCity }}, {{ props.option.companyRolodexJobLocationAddressState}})
              </div>
            </template>
          </b-autocomplete>
        </b-field>


        <location-list-modal @selected="notifyOnSelection" :show.sync="showLocationModal" />
      </div>
    </div>
</template>

<script>
import RolodexApi from '@/api-interface/rolordex'
import { debounce, flatten, isEmpty } from 'lodash-es'

import LocationListModal from '@/components/RolodexLocationList-Modal'

const DEBOUCE_DELAY = 300

export default {
  name: 'RolodexLocationSearch',
  props: {
    value: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      showLocationModal: false,
      isSearching: false,
      searchString: '',
      matches: []
    }
  },

  created() {
    this.searchString = this.value
  },

  computed: {
    /**
     *  Were results found or not?
     * @returns {Boolean}
     */
    noMatchesFound() {
      return this.matches.length === 0 && this.searchString.length !== 0 && this.isSearching === false
    }
  },

  components: {
    LocationListModal
  },

  methods: {
    toggleLocationModal() {
      this.showLocationModal = !this.showLocationModal
    },
    /**
     * Emit the `selected` event with the Rolodex object that was selected by the user
     * @param {Object} selection The object that was selected
     * @emits selected
     */
    notifyOnSelection(selection) {
      if (!isEmpty(selection)) {
        this.showLocationModal = false
        this.$emit('selected', selection)

        window.setTimeout(() => {
          this.searchString = selection.companyRolodexJobLocationName
        }, 50)
      }
    },

    /**
     * Emit the `input` event with the input string typed by the user
     * @emits input
     */
    notifyOnInputChange: debounce(async function() {
      this.$emit('input', this.searchString)
    }, DEBOUCE_DELAY),

    /**
     * Search for locations against the Rolodex API
     * Results are stored in the `matches` array.
     */
    search: debounce(async function() {
      this.isSearching = true
      if (this.searchString.length) {
        const locations = await RolodexApi.locationSearch({ name: this.searchString })

        // because locations have an array of addresses under them... we need to massage
        const formattedLocations = locations.map((loc) => {
          // flatten the location object so that it's easier to render a list of only address
          return loc.companyRolodexJobLocationAddresses.map((address) => ({ ...address, ...loc }))
        })

        this.matches = flatten(formattedLocations)
      } else {
        this.matches = []
      }
      this.isSearching = false
    }, DEBOUCE_DELAY)
  },

  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.searchString = this.value
      }
    }
  }
}
</script>

<style scoped>
.icon-help-text {
  margin-left: 5px;
}

li {
  padding: 8px 0;
}

li:hover {
  text-decoration: underline;
}
</style>
